import Skeleton from "react-loading-skeleton";
import "./StatBox.css";
import HelperText from "../HelperText/HelperText";

type Props = {
  name: string;
  isLoading: boolean;
  icon?: any;

  number?: any;
  component?: any;
  classname?: any;
  brand_color?: any;
  helperText?: any;
  showBreakdown?: boolean;
  breakdownData?: any;
};
function StatBox({
  name,
  number,
  icon,
  isLoading,
  component,
  classname,
  brand_color,
  helperText,
  showBreakdown,
  breakdownData,
}: Props) {
  return (
    <div
      className={classname ? classname : "stat-box-wrapper"}
      // style={{boxShadow:brand_color && `0 4px 6px -4px ${brand_color}`}}
    >
      <div className="stat-box-div">
        <p className="stat-box-title">
          {name}
          {helperText && <HelperText message={helperText} className="mt-2" />}
        </p>
        {icon}
      </div>
      {isLoading ? (
        <Skeleton />
      ) : typeof number === "number" ? (
        <p className="stat-box-number">{number}</p>
      ) : (
        component
      )}

      {showBreakdown && (
		<>
        <div
          style={{
            marginTop: 12,
            borderTop: "1px solid #eee",
            paddingTop: 8,
            fontSize: 13,
            color: "#444",
          }}
        >
					<label style={{fontSize:12,color:"#444",fontWeight:500}}>Breakdown</label>

          {breakdownData && Object.keys(breakdownData).length > 0 ? (
            Object.entries(breakdownData).map(
              ([source, count]: [string, any], index: number) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "2px 0",
                    borderBottom: "1px dashed #f0f0f0",
                    fontSize: 13,
                    color: "#444",
                  }}
                >
                  <span
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: 120,
                    }}
                  >
                    {source}
                  </span>
                  <span style={{ fontWeight: 500, color: "#888" }}>
                    {count}
                  </span>
                </div>
              )
            )
          ) : (
            <div style={{ color: "#aaa", fontSize: 12 }}>No sources yet</div>
          )}
        </div>
		</>
      )}
    </div>
  );
}

export default StatBox;
